import FAQ from "@components/FAQ";
import { styled } from "@sourceful/shared-components";
import { SanityFAQSection } from "@sourceful/shared-types";
import toRem from "@styles/postprocess/conversion/to-rem";
import { BasePageSection } from "../BasePageSection";

import { FAQPage } from "@24hr/react-structured-data";
import { toPlainText } from "@portabletext/react";

const FAQWrapper = styled("div", {
  maxWidth: toRem(720),
  margin: "0 auto",
  marginTop: toRem(70),
  marginBottom: toRem(40),
});

interface FAQSectionProps {
  section: SanityFAQSection;
}

export const FAQSection = ({ section }: FAQSectionProps) => {
  return (
    <BasePageSection section={section}>
      <FAQWrapper>
        <FAQ faqItems={section.faqItems} />
      </FAQWrapper>
      <FAQPage
        questions={section.faqItems.map(item => ({
          question: item.title,
          answer: toPlainText(item.content),
        }))}
      />
    </BasePageSection>
  );
};

export default FAQSection;
